import { createClient } from '@supabase/supabase-js';

// ═══════════════════════════════════════════════════════════
// CONFIGURACIÓN — Reemplazar con tus datos de Supabase
// Los encuentras en: Supabase → Settings → API
// ═══════════════════════════════════════════════════════════
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://TU-PROYECTO.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'tu-anon-key-aqui';

// Bloque 32 (C): identidad en cada petición. Con sesión, todas las llamadas (REST, RPC, Storage, Functions)
// llevan el header `x-c100-usuario` = "<Nombre> (admin <id>)" o "<Nombre> (agente <id>)"; la base lo lee para
// registrar quién hizo cada cambio (auditoría, Bloque 33). Sin sesión, sin header. Un solo cliente: el fetch
// envolvente agrega el header en el momento, así no hay que recrear el cliente al entrar o salir.
let usuarioC100 = null;
// Los headers solo admiten Latin-1: se quitan diacríticos y cualquier carácter fuera de ese rango.
const aLatin1 = (t) => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\x20-\xFF]/g, '').trim();
export const setUsuarioC100 = (texto) => { usuarioC100 = texto ? aLatin1(texto).slice(0, 120) : null; };
export const getUsuarioC100 = () => usuarioC100;
export const textoUsuarioC100 = (tipo, nombre, id) => `${String(nombre || '').trim() || (tipo === 'admin' ? 'admin' : 'agente')} (${tipo} ${id})`;

const fetchConUsuario = (url, opciones = {}) => {
  if (!usuarioC100) return fetch(url, opciones);
  const headers = new Headers(opciones.headers || {});
  headers.set('x-c100-usuario', usuarioC100);
  return fetch(url, { ...opciones, headers });
};

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, { global: { fetch: fetchConUsuario } });
